module.exports = __webpack_public_path__ + "img/logo50.2ddadb26.png";